import initializeValues from './initializeValues';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (contactId) => (dispatch) => {
    dispatch(initializeValues({ contact: contactId }));
    dispatch(setIsNewRecord(true));
    dispatch(openModal(true));
};
